var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelivered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M112,416a24,24,0,1,0-24-24A24.027,24.027,0,0,0,112,416Zm0-32a8,8,0,1,1-8,8A8.009,8.009,0,0,1,112,384Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,368a24,24,0,1,0,24,24A24.027,24.027,0,0,0,400,368Zm0,32a8,8,0,1,1,8-8A8.009,8.009,0,0,1,400,400Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488,96H410.97A103.832,103.832,0,0,0,260,97.08,7.851,7.851,0,0,0,256,96H184a8,8,0,0,0-8,8v56H88a8.019,8.019,0,0,0-6.95,4.03l-13.71,24-50.29,88A8.017,8.017,0,0,0,16,280V392a8,8,0,0,0,8,8H64.68a48.089,48.089,0,0,0,20.83,32H17a8,8,0,0,0,0,16H464a8,8,0,0,0,0-16H426.49a48.089,48.089,0,0,0,20.83-32H488a8,8,0,0,0,8-8V104A8,8,0,0,0,488,96ZM336,80a88,88,0,1,1-88,88A88.1,88.1,0,0,1,336,80ZM78.93,200H136v72H37.79ZM32,312H48a8,8,0,0,1,0,16H32Zm32.68,72H32V344H48a24,24,0,0,0,0-48H32v-8H144a8,8,0,0,0,8-8V192a8,8,0,0,0-8-8H88.07l4.57-8H176V384H159.32a47.99,47.99,0,0,0-94.64,0ZM112,424a32,32,0,1,1,32-32A32.036,32.036,0,0,1,112,424Zm26.49,8a48.089,48.089,0,0,0,20.83-32H352.68a48.089,48.089,0,0,0,20.83,32ZM400,424a32,32,0,1,1,32-32A32.036,32.036,0,0,1,400,424Zm80-40H447.32a47.99,47.99,0,0,0-94.64,0H192V336H480Zm0-64H192V112h56.4a104,104,0,1,0,175.2,0H480Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496,432h-8a8,8,0,0,0,0,16h8a8,8,0,0,0,0-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.2,198.4l32,24a8,8,0,0,0,10.821-1.132l56-64a8,8,0,1,0-12.042-10.536l-51.114,58.416L300.8,185.6a8,8,0,0,0-9.6,12.8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivered);
export default __webpack_public_path__ + "static/media/delivered.48d06be7dfa26b7d5207ddcb7b8bb8c5.svg";
export { ForwardRef as ReactComponent };